export const TOGGLE_EDIT_MODAL_COLUMN = 'TOGGLE_EDIT_MODAL_COLUMN';
export const TOGGLE_DELETE_MODAL_COLUMN = 'TOGGLE_DELETE_MODAL_COLUMN';
